import { useCallback, useEffect, useMemo } from 'react';
import { useLiveSocket } from '../useWebSocket';

export interface LiveActivityEvent {
  type: string;
  captureStartAt: string;
  details: any;
}

export function useLiveViewWebsocket(
  jobsiteId: string,
  token: string,
  onConnect: () => void,
  onEvent: (event: LiveActivityEvent) => void,
  setConnectionStatus: (status: string) => void
) {
  const handleConnect = useCallback(() => {
    setConnectionStatus('connected');
    onConnect();
  }, [setConnectionStatus, onConnect]);

  const handleEvent = useCallback(
    (data: any) => {
      try {
        const event = JSON.parse(data);

        if (!event.capture_start_at) return;

        onEvent({
          type: event.type,
          captureStartAt: event.capture_start_at,
          details: {
            ocr_text: event.ocr_text,
          },
        });
      } catch (err) {
        console.error('Error parsing websocket message', err);
      }
    },
    [onEvent]
  );

  const callbacks = useMemo(
    () => ({
      onEvent: handleEvent,
      onConnect: handleConnect,
      onDisconnect: () => setConnectionStatus('disconnected'),
      onConnectError: () => setConnectionStatus('disconnected'),
    }),
    [handleConnect, handleEvent, setConnectionStatus]
  );

  const { readyState, connect } = useLiveSocket(jobsiteId, token, callbacks);

  useEffect(() => {
    if (token && readyState === 0) {
      console.log('** connect to websocket **');
      connect();
    }
  }, [token, connect, readyState]);
}
